import { render, staticRenderFns } from "./onilnepayment.vue?vue&type=template&id=35bbfa3a"
import script from "./onilnepayment.vue?vue&type=script&lang=js"
export * from "./onilnepayment.vue?vue&type=script&lang=js"
import style0 from "./onilnepayment.vue?vue&type=style&index=0&id=35bbfa3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports